import { VariablesType } from './VariablesMenu.enum';
import { tListVariables } from './VariablesMenu.types';

export const listVariables: tListVariables[] = [
  {
    name: VariablesType.NAME,
    value: 'name',
  },
  {
    name: VariablesType.EMAIL,
    value: 'email',
  },
  {
    name: VariablesType.PHONE,
    value: 'phone',
  },
  {
    name: VariablesType.COMPANY,
    value: 'Company',
  },
];
